import { useCallback, useEffect, useState } from "react";
import { Marker, Pane } from "react-leaflet";
import L, { MarkerCluster, icon } from "leaflet";
import { useAppSelector } from "Hooks/useRedux";
import useSurveys from "Hooks/useSurveys";
import MarkerClusterGroup from "react-leaflet-cluster";
import SourceSvg from "Assets/Images/Survey/source-icon.svg";
import destinationSvg from "Assets/Images/Survey/destination-icon.svg";
import useTravels from "Hooks/useTravels";

const ICON_SIZE = 22;

const destinationIcon = icon({ iconUrl: destinationSvg, iconSize: [ICON_SIZE, ICON_SIZE] });
const sourceIconIcon = icon({ iconUrl: SourceSvg, iconSize: [ICON_SIZE, ICON_SIZE] });

export default function TravelMarkerCluster() {
  const { zone } = useAppSelector((state) => state.zones);
  const { visible, markerMode } = useAppSelector((state) => state.travel);
  const { survayLayer } = useAppSelector((state) => state.layers);

  const { data } = useTravels();
  const [radius, setRadius] = useState<number>(50);

  const handleDestinationsMarker = (dat: any) => {
    return dat?.map((item: any, indx: number) => {
      if (!item.Result || indx > 100) return;
      const travel = JSON.parse(`{${item.Result}}`);
      return <Marker position={[travel.destination_lat, travel.destination_lng]} icon={destinationIcon} />;
    });
  };

  const handleSourcesMarker = (dat: any) => {
    return dat?.map((item: any, indx: number) => {
      if (!item.Result || indx > 100) return;
      const travel = JSON.parse(`{${item.Result}}`);
      return <Marker position={[travel.source_lat, travel.source_lng]} icon={sourceIconIcon} />;
    });
  };

  const handleSetDestinationClass = (n: number) => {
    if (n < 50) {
      return "marker-cluster marker-cluster-small destination-s";
    }
    if (n >= 50 && n < 100) {
      return "marker-cluster marker-cluster-medium destination-m";
    }
    return "marker-cluster marker-cluster-large destination-l";
  };

  const handleSetSourceClass = (n: number) => {
    if (n < 50) {
      return "marker-cluster marker-cluster-small source-s";
    }
    if (n >= 50 && n < 100) {
      return "marker-cluster marker-cluster-medium source-m";
    }
    return "marker-cluster marker-cluster-large source-l";
  };

  const createDestinationCustomIcon = useCallback(function (cluster: MarkerCluster) {
    return L.divIcon({
      html: `<div><span>${cluster.getChildCount()}</span></div>`,
      className: handleSetDestinationClass(cluster.getChildCount()),
      iconSize: L.point(40, 40, true),
    });
  }, []);

  const createSourceCustomIcon = useCallback(function (cluster: MarkerCluster) {
    return L.divIcon({
      html: `<div><span>${cluster.getChildCount()}</span></div>`,
      className: handleSetSourceClass(cluster.getChildCount()),
      iconSize: L.point(40, 40, true),
    });
  }, []);

  if (!visible) return <></>;
  return (
    <>
      {" "}
      <Pane name={`${Math.random()}show_travel_marker`} style={{ zIndex: survayLayer }} key={`${zone}${survayLayer}`}>
        {markerMode.includes("source") ? (
          <MarkerClusterGroup chunkedLoading maxClusterRadius={radius} iconCreateFunction={createSourceCustomIcon}>
            {handleSourcesMarker(data)}
          </MarkerClusterGroup>
        ) : null}
        {markerMode.includes("destination") ? (
          <MarkerClusterGroup chunkedLoading maxClusterRadius={radius} iconCreateFunction={createDestinationCustomIcon}>
            {handleDestinationsMarker(data)}
          </MarkerClusterGroup>
        ) : null}
      </Pane>
    </>
  );
}
